import Vue from 'vue'
import router from '@/router'
import api from '@puzzleapps/shared/src/utils/api'



// TODO: Make cells array one dimensional
const state = {
    cols: 0,
    rows: 0,
    cells: [], // 2x2 array of cell objects+
    selectedCell: null, // cell model
    lastSelectedCell: null, // cell model
    loaded: false,
}

const getters = {
  getRows: (state) => state.rows,
  getCols: (state) => state.cols,
  getSelectedCell: (state) => state.selectedCell,

  getCellGroup: (state) => (group) => {
    let cellGroup = [];
    for (let i = 0; i < state.rows; i++) {
      for (let j = 0; j < state.cols; j++) {
        if (state.cells[i][j].group === group)
          cellGroup.push(state.cells[i][j]);
      }
    }
    return cellGroup;
  },

  getCellGroups: (state) => {
    if (!state.cells.length) return;

    let cellGroups = [];

    for (let i = 0; i < state.rows; i++) {
      for (let j = 0; j < state.cols; j++) {
        let g = state.cells[i][j].group;
        if (!cellGroups[g]) cellGroups[g] = [];
        if (state.cells[i] && state.cells[i][j])
          cellGroups[g].push(state.cells[i][j]);
      }
    }

    return cellGroups;
  },

  getCellAtPosition: (state) => (row, col) => {
    if (
      row >= 0 &&
      row < state.rows &&
      col >= 0 &&
      col < state.cols &&
      state.cells[row] &&
      state.cells[row][col]
    )
      return state.cells[row][col];
    else return false;
  },
  getSolutionAtPosition: (state) => (row, col) => {
    return state.cells[row][col].solution;
  },
  getGroupAtPosition: (state) => (row, col) => {
    return state.cells[row][col].group;
  },
  getGivenAtPosition: (state) => (row, col) => {
    return state.cells[row][col].given;
  },
  getInputAtPosition: (state) => (row, col) => {
    return state.cells[row][col].input;
  },
  getRowAtPosition: (state) => (row) => {
    return state.cells[row];
  },
  isGivenAtPosition: (state) => (row, col) => {
    return state.cells[row][col].given;
  },

  getUserinputs: (state) => {
    let inputs = [];
    for (let i = 0; i < state.rows; i++) {
      for (let j = 0; j < state.cols; j++) {
        inputs.push(state.cells[i][j].input);
      }
    }
    if (inputs.length) return inputs;
  },
};


const actions = {

    // iterate over every cell and run a callback
    forEachCell({ state }, callback) {
        for (let row = 0; row < state.rows; row++) 
        {
            for (let col = 0; col < state.cols; col++) 
            {
                const cell = state.cells[row][col]
                callback(cell, row, col)
            }
        }
    },

    fetchPuzzle({ commit, dispatch, rootState, state }) {},

    loadUserDataFromLocal({ dispatch, rootState }, puzzleId) {
        let local = localStorage.getItem(`puzzle-${ puzzleId }`)

        if (!local || local === 'undefined') return

        local = JSON.parse(local)

        if (rootState.game.type === 'wordsearch') 
        {
            dispatch('wordlist/setInputsFromLocal', local, {root: true})
            return
        }

        dispatch('setInputsFromLocal', local)
    },

    setInputsFromLocal({ state, commit, dispatch }, local) {
        dispatch('forEachCell', cell => {
            commit('SET_USER_INPUT_AT_POS', {
                row: cell.row,
                col: cell.col,
                input: local.inputs[0],
            })
            local.inputs.shift()
        })
    },

    selectCell({ commit }, payload) {        
        // TODO sort out these global events
        // Event.fire('cell-selected', payload)
        commit('SET_SELECTED_CELL', payload)
    },

    revealSelected({ commit, state, dispatch }) {
        return new Promise((resolve) => {

            let cellsAlreadyCorrect = true

            if(state.selectedCell.input != state.selectedCell.solution)
            {
                cellsAlreadyCorrect = false
                commit('SET_USER_INPUT_AT_POS', {
                    row: state.selectedCell.row,
                    col: state.selectedCell.col,
                    input: state.selectedCell.solution,
                })
            }
            
            dispatch('checkCompleted')
            resolve(cellsAlreadyCorrect)
        })
    },

    setInputAtPos({ commit, dispatch, state, rootState, getters }, payload) {},

    checkCompleted({ dispatch, state, rootState, commit }) {
        if (rootState.game.type === 'wordsearch') 
        {
            dispatch('wordlist/checkWordsearchCompleted', null, {root: true})
            return
        }

        else 
        {
            // TODO refactor with a flat array
            for (let i = 0; i < state.rows; i++) 
            {
                for (let j = 0; j < state.cols; j++) 
                {
                    let cell = state.cells[i][j]
                    if (!cell.isCorrect()) 
                    {
                        dispatch('game/setCompleted', false, { root: true })
                        return
                    }
                }
            }
            // if all cells are correct finish game
            dispatch('game/finishGame', null, { root: true })


        }
    },

    clearAllInputs({ dispatch, commit, state }) {

        for (let i = 0; i < state.rows; i++) 
        {
            for (let j = 0; j < state.cols; j++) 
            {
                commit('SET_USER_INPUT_AT_POS', {
                    row: i,
                    col: j,
                    input: 0,
                })
            }
        }
        dispatch('checkCompleted')
    },

    clearCells({ commit }) {
        commit('CLEAR_CELLS')
    },

    // sudoku

    // pos = {row, col, input}
    setMarkAtPos({ commit, dispatch, state }, payload) {
        if (!payload) 
            throw new Error('Cell row and payloadition required. Given: ' + payload)

        // if (!payload.isUndo) {            
        //     dispatch('undoRedo/clearRedoHistory', null, { root: true })
        //     dispatch('undoRedo/pushHistory', {
        //         row: payload.row,
        //         col: payload.col,
        //         input: state.cells[payload.row][payload.col].input,
        //         isMark: true,
        //     }, { root: true })
        // }
        
        commit('SET_USER_MARK_AT_POS', payload)
    },

    removeMarkAtPos({ commit }, payload) {
        if (!payload) 
            throw new Error('Cell row and payloadition required. Given: ' + payload)
        
        commit('REMOVE_USER_MARK_AT_POS', payload)
    },

    clearSelected: ({ dispatch, commit, state }) => {
        
        if(state.isPencil){
            dispatch('game/clearPencilMarks', null, {root: true})
        }
        else{
            commit('SET_USER_INPUT_AT_POS', {
                row: state.selectedCell.row,
                col: state.selectedCell.col,
                input: 0,
            })
            dispatch('checkCompleted')
        }
    },
    
    toggleIsPencil({ commit }) {        
        commit('TOGGLE_IS_PENCIL')
    },

    // crossword 
    
    toggleIsAcross({ commit }) {  
        commit('TOGGLE_IS_ACROSS')
    },
    
    // setIsAcross({ commit }, val) {  
    //     commit('SET_IS_ACROSS', val)
    // },
    
    // cnAndDir = {clueNumber, direction}
    
    revealWord({ dispatch, commit, state }) {
        return new Promise((resolve) => {
            let clue = state.isAcross ? 
            state.selectedCell.clues.across :
            state.selectedCell.clues.down
            let cellsAlreadyCorrect = false

            let lastselectedCell = state.selectedCell;

            let iCorrectLetterCounter = 0;
            let iLetterCounter = 0;
            for (let i in clue.cells) 
            {
                iLetterCounter++;
                let cell = clue.cells[i]

                lastselectedCell = cell;
                if(cell.input != cell.solution)
                {
                    commit('SET_USER_INPUT_AT_POS', {
                        row: cell.row,
                        col: cell.col,
                        input: cell.solution,
                    })
                }
                else
                {
                    iCorrectLetterCounter ++;
                }
            }

            if(iLetterCounter == iCorrectLetterCounter)
            {
                cellsAlreadyCorrect = true;
            }
            else
            {
                cellsAlreadyCorrect = false;
            }

            let payload = 

                    // move to the next cell
                    
            dispatch('selectNextLetter', {row:lastselectedCell.row, col:lastselectedCell.col})

            dispatch('checkCompleted') // check to see if this hint finishes the puzzle
            resolve({ cellsAlreadyCorrect: cellsAlreadyCorrect, hintsUsed: iLetterCounter - iCorrectLetterCounter })
        })
    },

    async revealCodeCrackerLetters({ dispatch, commit, state })
    {
        let cellsAlreadyCorrect = false
        let cell = state.selectedCell;

        let clueNumber = cell.clueNumber

        if(cell.input != cell.solution)
        {
            let AllCells = state.cells
            
            if(cell.input != 0)
            {
                let OriginalValue = cell.input.toUpperCase()
                // re-enables the key if a hint was used on a cell with a wrong letter
                dispatch('keyboard/enableKey', OriginalValue, { root: true }) 
            }

            for(var i = 0; i < AllCells.length; i++)
            {
                // Inner loop to get cell details
                for(var j = 0; j < AllCells[i].length; j++)
                {
                    if(!AllCells[i][j].isBlack)
                    {
                        if(AllCells[i][j].clueNumber === clueNumber)
                            AllCells[i][j].input = AllCells[i][j].solution;
                    }
                    
                }
            }

            
            // disable the key on the keyboard
            //dispatch('keyboard/disableKey', cell.solution.toUpperCase(), { root: true })  old way
            dispatch('keyboard/correctKey', cell.solution.toUpperCase(), { root: true })

            // check to see if it is completed
            dispatch('checkCompleted')
            
        }
        else{
            cellsAlreadyCorrect = true;
            
        }

        return cellsAlreadyCorrect;
    },

   async revealLetter({ dispatch, commit, state }) {
        let cellsAlreadyCorrect = false
        let cell = state.selectedCell;

        if(cell.input != cell.solution)
        {
            commit('SET_USER_INPUT_AT_POS', {
                row: cell.row,
                col: cell.col,
                input: cell.solution,
            })
            
            dispatch('checkCompleted')
            
        }
        else{
            cellsAlreadyCorrect = true;
            
        }

        if(state.type != 'codecracker')
        {
            // move to the next cell
            dispatch('selectNextLetter', {row:cell.row, col:cell.col})
        }


        return cellsAlreadyCorrect;
    },

    revealAllCrossword({ dispatch, commit, state }){
        //** This reveals all the letters on the crossword and probably won't be used */
        
        let remaining = false
        let gC = state.cells

        for(var i = 0; i < gC.length; i++)
        {
            // Inner loop to get cell details
            for(var j = 0; j < gC[i].length; j++)
            {
                if(!gC[i][j].isBlack)
                {
     
                    gC[i][j].input = gC[i][j].solution;
                }
                
            }
        }

    },

    selectCellByClueNumber({ commit, state }, cnAndDir) {

        commit('SET_IS_ACROSS', cnAndDir.direction === 'across')          

        for (let i = 0; i < state.rows; i++) 
        {
            for (let j = 0; j < state.cols; j++) 
            {
                if (state.cells[i][j].clueNumber === cnAndDir.clueNumber) 
                {
                    let cell = state.cells[i][j]
                    commit('SET_SELECTED_CELL', {row: cell.row, col: cell.col})
                    return cell
                }
            }
        }
    },

    // crossword only
    // this does the original Alex method where the down clues go down and across and ignore going by down clue sequentially
    selectNextLetter_keyboard({ dispatch, state, rootState }, pos) {  

        if(rootState.game.type === 'crossword'){
            let cells = state.cells

            state.isAcross ? pos.col++ : pos.row++
            
            if (pos.row >= state.rows && state.isAcross) 
            {
                dispatch('toggleIsAcross')
                return dispatch('selectNextLetter_keyboard', {row:-1, col:0}) // cycle back to 0,0
            }
            
            if (pos.col >= state.cols && !state.isAcross) 
            {
                dispatch('toggleIsAcross')
                return dispatch('selectNextLetter_keyboard', {row:0, col:-1}) // cycle back to 0,
            }
            
            if (pos.row >= state.rows && !state.isAcross)    
                return dispatch('selectNextLetter_keyboard', {row:-1, col:pos.col+1}) // new col
            
            if (pos.col >= state.cols && state.isAcross) 
                return dispatch('selectNextLetter_keyboard', {row:pos.row+1, col:-1}) // new row

            if (
                state.isAcross && !cells[pos.row][pos.col].hasAcrossWord() ||
                !state.isAcross && !cells[pos.row][pos.col].hasDownWord()
            ) {
                return dispatch('selectNextLetter_keyboard', {row:pos.row, col:pos.col})
            }
                    
            dispatch('selectCell', {row: pos.row, col: pos.col})
            dispatch('cluelist/selectCluesByCell', state.cells[pos.row][pos.col], {root: true})
        }
    },

    // new/proper method where the down clues go by clue number
    selectNextLetter_keyboard2({dispatch, state, rootState}, payload) {  
        let cells = state.cells

        if(!rootState.game.completed){
        state.isAcross ? payload.col++ : payload.row++

        if (state.isAcross) 
        {
            if(payload.row >= state.rows) // also the last row so switch to down mode
            {   
                dispatch('toggleIsAcross')
                let newpayload = {row:-1, col:0, nextClueNum: 0}
                return dispatch('selectNextLetter_keyboard2', newpayload )
            } 

            if (payload.col >= state.cols) // last col in the row
            {
                let newpayload = {row:payload.row+1, col:-1, nextClueNum: 0 }
                return dispatch('selectNextLetter_keyboard2', newpayload) // new row
            }
                    

            if(!cells[payload.row][payload.col].hasAcrossWord()){
                let newpayload = {row:payload.row, col:payload.col, nextClueNum: 0}
                return dispatch('selectNextLetter_keyboard2', newpayload )
            }

        }
        else
        {
            if (payload.col >= state.cols) // last col in the row
                return 

            if (payload.row >= state.rows || cells[payload.row][payload.col].isBlack) // cell is either off the bottom or is black
            {
                // ## Jump to the next question in the down list

                let currentClueNum = 0 

                if(state.selectedCell.clues.down !== null)
                    currentClueNum = state.selectedCell.clues.down.clueNumber

                if(payload.nextClueNum > 0){
                    currentClueNum = payload.nextClueNum
                }
                const clueList = rootState.cluelist.clues;
            
                const nextClue = clueList.find((clue) => {
                  return clue.direction === 'down' && clue.clueNumber > currentClueNum;
                });
              
                if (nextClue) {
                  const nC = nextClue.cells[0];
                 
                  let nCRow= nC.row
                  let nCCol = nC.col

                  let newpayload = { row: nCRow -1, col: nCCol, nextClueNum: nextClue.clueNumber}
                  
                  return dispatch('selectNextLetter_keyboard2', newpayload) // new row
                }
                else
                {
                    //switch to across mode and go back to the start
                    dispatch('toggleIsAcross')
                    let newpayload = {row:0, col:-1, nextClueNum: 0}
                    return dispatch('selectNextLetter_keyboard2', newpayload )
                }

            }

        }

        dispatch('selectCell', {row: payload.row, col: payload.col})
        dispatch('cluelist/selectCluesByCell', state.cells[payload.row][payload.col], {root: true})
        }

    },

        // crossword only
    selectNextLetter({ dispatch, state, rootState }, pos) {  

    // move to the next cell that isn't black and isn't filled out
        if(rootState.game.type === 'crossword'){

        // from current position. 
        // Check if isAcross mode is true 
        // if yes then move to the next cell to the right
        // do until cell isBlack = false, and input is blank
            // get the position of that cell and move to it


            let selectedCell = state.selectedCell
            let gC = state.cells

            let startCol = selectedCell.col
            let startRow = selectedCell.row

            let thisPos = {row: startRow, col: startCol}



            if(state.isAcross){
                    dispatch('searchRowForNextBlank', thisPos)

            }
            else
            {
                //dispatch('searchRowForNextBlank', pos)
                dispatch('searchColForNextBlank2', "fast")
            }
        }
    },

 
    jumpToBlank({dispatch, state, getters, rootState}, payload){
        let cells = state.cells

        if(!rootState.game.completed){
        state.isAcross ? payload.col++ : payload.row++

        if (state.isAcross) 
        {
            
            if(payload.row >= state.rows) // also the last row so switch to down mode
            {   
                return 
            } 

            if (payload.col >= state.cols) // last col in the row
            {
                let newpayload = {row:payload.row+1, col:-1, nextClueNum: 0 }
                return dispatch('jumpToBlank', newpayload) // new row
            }
                    

            if(cells[payload.row][payload.col].hasAcrossWord()){
                if(!cells[payload.row][payload.col].isBlank())
                {
                    let newpayload = {row:payload.row, col:payload.col, nextClueNum: 0}
                    return dispatch('jumpToBlank', newpayload)
                }

            }
            else
            {
                let newpayload = {row:payload.row, col:payload.col, nextClueNum: 0}
                return dispatch('jumpToBlank', newpayload )
            }
            
        }
        else
        {
            if (payload.col >= state.cols) // last col in the row
                return 

            if (payload.row >= state.rows || cells[payload.row][payload.col].isBlack) // cell is either off the bottom or is black
            {
                // ## Jump to the next question in the down list
                var currentClueNum = state.selectedCell.clues.down.clueNumber 

                if(payload.nextClueNum > 0){
                    currentClueNum = payload.nextClueNum
                }
                const clueList = rootState.cluelist.clues;
            
                const nextClue = clueList.find((clue) => {
                  return clue.direction === 'down' && clue.clueNumber > currentClueNum;
                });
              
                if (nextClue) {
                  const nC = nextClue.cells[0];
                 
                  let nCRow= nC.row
                  let nCCol = nC.col

                  let newpayload = { row: nCRow -1, col: nCCol, nextClueNum: nextClue.clueNumber}
                  
                  return dispatch('jumpToBlank', newpayload) // new row
                }
                else
                {
                    
                    return // there is no next down question
                }

            }
            if(cells[payload.row][payload.col].hasDownWord()){

                if(!cells[payload.row][payload.col].isBlank())
                {
                    if(cells[payload.row][payload.col].cellIsCorrect())
                    {
                        let newpayload = {row:payload.row, col:payload.col, nextClueNum: payload.nextClueNum}
                        return dispatch('jumpToBlank', newpayload )
                    }
                }
            }
            else
            {
                let newpayload = {row:payload.row, col:payload.col, nextClueNum: payload.nextClueNum}
                return dispatch('jumpToBlank', newpayload)
            }
        }

        dispatch('selectCell', {row: payload.row, col: payload.col})
        dispatch('cluelist/selectCluesByCell', state.cells[payload.row][payload.col], {root: true})
        }
    },

    searchRowForNextBlank({dispatch, state, getters, rootState}, pos)
    {
        var bFound = false;

        var row = pos.row;  
        var col = pos.col;

        let gC = state.cells;

        let NumOfCols = getters.getCols;
        let NumOfRows = getters.getRows;

        let sC = state.selectedCell;
        var ClueNum = sC.clues.across.clueNumber;

        let NumofClues = (rootState.cluelist.clues.length) 

        do{
            for(var iCol = col; iCol < NumOfCols; iCol++)
            {
                if (!gC[row][iCol].isBlack){
                    if(gC[row][iCol].input == 0){
                        bFound = true;
                        if(iCol == 0){
                            if(gC[row][iCol+1].isBlack){
                                bFound = false;
                            }
                        }
                        if(iCol == NumOfCols - 1){
                            if(gC[row][iCol-1].isBlack){
                                bFound = false;
                            }
                        }


                    }
                } 

                //do a search for cells that aren't on the far left or right and don't have a black cell on both sides
                if(iCol > 0 && iCol < NumOfCols - 1)
                {
                    if(gC[row][iCol - 1].isBlack && gC[row][iCol + 1].isBlack)
                    {
                        bFound = false;
                    }
                }

                if(bFound)
                    {
                        
                        dispatch('selectCell', {row: row, col: iCol})
                        dispatch('cluelist/selectCluesByCell', state.cells[row][iCol], {root: true})

                        break;
                    }
            }

            row++;
            col=0;

            if(row == NumOfRows)
            {
                bFound = true; //exit this loop

            }

            
        }while(!bFound)
    },



    searchColForNextBlank({dispatch, state, getters}, pos)
    {
    var bFound = false;

    var bExit = false;

    var row = pos.row;  
    var col = pos.col;

    let gC = state.cells;

    let NumOfCols = getters.getCols;
    let NumOfRows = getters.getRows;

    do{
        for(var iRow = row; iRow < NumOfRows; iRow++)
        {
            
            if (!gC[iRow][col].isBlack){
                if(gC[iRow][col].input == 0 ){ //cell isn't black and hasn't been filled in
                    bFound = true;
                    if(iRow == 0){ // if the cell is in the top row
                        if(gC[iRow+1][col].isBlack){ //and the cell below it is black
                            bFound = false;
                        }
                    }
                    if(iRow == NumOfRows - 1){ // if the cell is in the bottom row
                        if(gC[iRow -1][col].isBlack){ // if the cell above it is black
                            bFound = false;
                        }
                    }
                }
            } 

            //do a search for cells that aren't on the top or bottom row and don't have a black cell above and below
            
            if(iRow > 0 && iRow < NumOfRows - 1)
            {
                if(gC[iRow - 1][col].isBlack && gC[iRow + 1][col].isBlack)
                {
                    bFound = false;
                }
            }

            if(col == NumOfCols -1 && iRow == NumOfRows -1) // last column and last row so exit
                bExit = true;

            if(bExit)
            {
                if(!gC[iRow][col].isBlack){
                    dispatch('selectCell', {row: iRow, col: col})
                    dispatch('cluelist/selectCluesByCell', state.cells[iRow][col], {root: true})
                }
                
                break;
            }
                

            if(bFound)
            {
                
                dispatch('selectCell', {row: iRow, col: col})
                dispatch('cluelist/selectCluesByCell', state.cells[iRow][col], {root: true})

                break;
            }
        }
        row=0;
        col++;
        //col = col >= NumOfCols ? NumOfCols - 1 : col;

    }while(!bFound && !bExit)
    },

    setCrosswordStart({dispatch, state, getters,commit, rootState})
    {

        
    },
    searchColForNextBlank2({dispatch, state, rootState}, mode = 'fast')
    {
    var bFound = false;

    let gC = state.cells;

    let sC = state.selectedCell;

    var row = sC.row;  
    var col = sC.col;

    var ClueNum = sC.clues.down.clueNumber;
    let OriginalClueNum = ClueNum;

   

    var ClueList = rootState.cluelist;
    
    var CluesCount = ClueList.clues.length;
    
    var solLetters = sC.clues.down.cells.length;


    //1. Save all the down clues into an object and into an array
    var ClueArray = [];
    
    for(var clueNo = 0; clueNo < CluesCount; clueNo++)
        {
            if(ClueList.clues[clueNo].direction == 'down'){
                let clueDetails = {
                    clueNum: ClueList.clues[clueNo].clueNumber,
                    startRow: ClueList.clues[clueNo].cells[0].row,
                    startCol: ClueList.clues[clueNo].cells[0].col,
                    solLen: ClueList.clues[clueNo].cells.length
                }

                ClueArray.push(clueDetails);
            }
        }

    //2. Loop thru the array
        

        let bFirstLoop = true;
        for(let i = 0; i < ClueArray.length; i++){
            

            if(!bFound && ClueArray[i].clueNum >= ClueNum)
            {
                let startRow = ClueArray[i].startRow;
                let startCol = ClueArray[i].startCol;
                let solLetters = ClueArray[i].solLen;

                if(row == 0)
                    row = startRow;

                //row = startRow;
                let nextCell = NextDownClueCell(gC,row,startCol,startRow,solLetters, mode);
                

                if(nextCell.row >= 0)
                {

                        bFound = true;

                        dispatch('selectCell', {row: nextCell.row, col: nextCell.col})
                        dispatch('cluelist/selectCluesByCell', state.cells[nextCell.row][nextCell.col], {root: true})

                }
                else
                {
                    row = 0;
                }


            }
        }



    },

    // crossword only
    backLetter({ dispatch, state }, pos) {  
        let CanBackLetter = true;
        let cells = state.cells

       //1. No if isAcross is true and we are in the first row (ie pos.row = 0) and there are either no columns to the left or the left cell is black
       if(state.isAcross && pos.row == 0)
       {
            if(pos.col == 0 || cells[pos.row][pos.col-1].isBlack)
                CanBackLetter = false;
       }

        //2. No if isAcross is false and we are in the first column (ie pos.col = 0) and there are either no rows above or the cell above is black
        if(!state.isAcross && pos.col == 0)
        {
            if(pos.row == 0 || cells[pos.row-1][pos.col].isBlack)
                CanBackLetter = false; 
        }      

        //3. No if isAcross is true and the cell is not in the top row and the cell to the left isBlack
        if(state.isAcross && pos.row > 0)
        {
            if(pos.col == 0 || cells[pos.row][pos.col-1].isBlack)
                CanBackLetter = false;
        }

        //4. No if isAcross is false and the cell above isBlack
        if(!state.isAcross && pos.col > 0)
        {
            if(pos.row == 0 || cells[pos.row-1][pos.col].isBlack)
                CanBackLetter = false; 
        }  

        
        if(!CanBackLetter)
        {
            return
        }
        
        /*if (
            pos.col == 0 ||
            pos.row == 0 ||
            state.isAcross && cells[pos.row][pos.col-1].isBlack ||
            !state.isAcross && cells[pos.row-1][pos.col].isBlack
        ) {
            return 
        }*/
        state.isAcross ? pos.col-- : pos.row--                
        dispatch('selectCell', {row: pos.row, col: pos.col})
    },
    canUseBackLetter(pos,isAcross)
    {
        ret = true;
     },
     
     keyPress({ dispatch , state, rootState}, payload){
        // Used for letter games such as Crosswords and Codecracker
        //if(!rootState.game.completed)
        //{ 

          let keyPressed = payload.input;
          
          let cells = state.cells

          
          

        if (keyPressed === '{SHIFT}' || keyPressed === 'SHIFT')
        { 

            if(rootState.grid.isAcross){
                //don't toggle if both the cells above and below are black and 
                if(payload.row == 0) // rules for the top row
                {
                    if(!cells[payload.row+1][payload.col].isBlack){
                        dispatch('toggleIsAcross')
                    }
                }
                else // rules for all rows other than the top
                {
                    if(payload.row == state.rows-1) // rules for the bottom row
                    {
                        if(!cells[payload.row-1][payload.col].isBlack){
                            dispatch('toggleIsAcross')
                        }
                        
                    }
                    else
                    {
                        if(!cells[payload.row+1][payload.col].isBlack){
                            dispatch('toggleIsAcross')
                        }
                        else{
                            if(!cells[payload.row-1][payload.col].isBlack){
                                dispatch('toggleIsAcross')
                            }
   
                        }
                        
                    }
                }

            }
            else
            {
                //don't toggle if both the cells left and right are black 
                if(payload.col == 0) // rules for the top row
                {
                    if(!cells[payload.row][payload.col+1].isBlack){
                        dispatch('toggleIsAcross')
                    }
                }
                else // rules for all rows other than the top
                {
                    if(payload.col == state.cols-1) // rules for the bottom row
                    {
                        if(!cells[payload.row][payload.col-1].isBlack){
                            dispatch('toggleIsAcross')
                        }
                        
                    }
                    else
                    {
                        if(!cells[payload.row][payload.col+1].isBlack){
                            dispatch('toggleIsAcross')
                        }
                        else{
                            if(!cells[payload.row][payload.col-1].isBlack){
                                dispatch('toggleIsAcross')
                            }
   
                        }
                        
                    }
                }
            }
           
        }
    
        else{

            if(isLetter(keyPressed)){
                
                dispatch('grid/setInputAtPos', payload, {root: true})

                if(rootState.userSettings.crosswordJumpToBlank)
                {
                    let newPayload = {row:payload.row, col:payload.col, nextClueNum: 0}
                    dispatch('grid/jumpToBlank', newPayload, {root: true}) //move to the next available blank pos
                }
                else
                {
                    dispatch('grid/selectNextLetter_keyboard2', payload, {root: true}) //move to the next grid even if filled
                }
                
                
            }
            else if (keyPressed === '{BACKSPACE}' || keyPressed === 'BACKSPACE' || keyPressed === 'DELETE') {
                payload.input = 0
                dispatch('grid/setInputAtPos', payload, {root: true})
                dispatch('grid/backLetter', payload, {root: true})
            }
            else if (keyPressed === '{TAB}' || keyPressed === 'TAB' || keyPressed === '{ENTER}' || keyPressed === 'ENTER')
            {
                dispatch('cluelist/selectNextClue','',{root: true})
            }
            else if (keyPressed == 'ARROWDOWN')
            {
                if(payload.row + 1 < state.rows)
                {
                    if(!cells[payload.row+1][payload.col].isBlack)
                    {
                        if(state.isAcross && !cells[payload.row+1][payload.col].hasAcrossWord()) // This fixes a bug where the black cells get highlighted. We switch to down mode
                        {
                            dispatch('toggleIsAcross')
                        }
                        dispatch('selectCell', {row: payload.row+1, col: payload.col})
                        dispatch('cluelist/selectCluesByCell', state.cells[payload.row+1][payload.col], {root: true})
                    }
                }
            }
            else if (keyPressed == 'ARROWUP')
            {
                if(payload.row - 1 >= 0)
                {
                    if(!cells[payload.row-1][payload.col].isBlack)
                    {
                        if(state.isAcross && !cells[payload.row-1][payload.col].hasAcrossWord()) // This fixes a bug where the black cells get highlighted. We switch to down mode
                        {
                            dispatch('toggleIsAcross')
                        }
                        dispatch('selectCell', {row: payload.row-1, col: payload.col})
                        dispatch('cluelist/selectCluesByCell', state.cells[payload.row-1][payload.col], {root: true})
                    }
                }
            }
            else if (keyPressed == 'ARROWLEFT')
            {
                if(payload.col - 1 >= 0)
                {
                    if(!cells[payload.row][payload.col-1].isBlack)
                    {
                        if(!state.isAcross && !cells[payload.row][payload.col-1].hasDownWord()) // This fixes a bug where the black cells get highlighted. We switch to down mode
                        {
                            dispatch('toggleIsAcross')
                        }
                        dispatch('selectCell', {row: payload.row, col: payload.col-1})
                        dispatch('cluelist/selectCluesByCell', state.cells[payload.row][payload.col-1], {root: true})
                    }
                }
            }
            else if (keyPressed == 'ARROWRIGHT')
            {
                if(payload.col + 1 < state.cols)
                {
                    if(!cells[payload.row][payload.col+1].isBlack)
                    {
                        if(!state.isAcross && !cells[payload.row][payload.col+1].hasDownWord()) // This fixes a bug where the black cells get highlighted. We switch to down mode
                        {
                            dispatch('toggleIsAcross')
                        }
                        dispatch('selectCell', {row: payload.row, col: payload.col+1})
                        dispatch('cluelist/selectCluesByCell', state.cells[payload.row][payload.col+1], {root: true})
                    }
                }
            }
        //}
    }
        //dispatch('checkCompleted')
     },

    async moveToStartOfNextDownClue({ state, rootState, dispatch})
    {
        let clueNum = state.selectedCell.clues.down.clueNumber


        let ClueArray = rootState.cluelist.clues



        //** find the next clue starting cell coords */
        for(let i = 0; i < ClueArray.length; i++){

            if(ClueArray[i].direction === "down" && ClueArray[i].clueNumber > clueNum)
            {
                let NextclueNum = ClueArray[i].clueNumber

                let startRow = ClueArray[i].cells[0].row
                let startCol = ClueArray[i].cells[0].col
                    
                return {row: startRow, col: startCol}
            }

        }
        
        
    },

    async moveToStartOfNextDownClue2({ state, rootState, dispatch }) {
        const currentClueNum = state.selectedCell.clues.down.clueNumber;
        const clueList = rootState.cluelist.clues;
      
        const nextClue = clueList.find((clue) => {
          return clue.direction === 'down' && clue.clueNumber > currentClueNum;
        });
      
        if (nextClue) {
          const { row, col } = nextClue.cells[0];
          return { row, col };
        }
      
        // Handle case when no more clues are found
        throw new Error('No more down clues found.');
      },

      deselectAllCells({commit})
      {
        commit('DESELECT_ALL_CELLS')
      }
      
    //toggleIsAcross({ dispatch, state }, pos) { 

    //},



}
function NextDownClueCell(grid, startRow, startCol, clueStartRow, Length, mode = "fast"){

    
    var ret = {row: -1,col:-1};

    let bFound = false;
    

    for(let i = clueStartRow; i < Length + clueStartRow; i++)
    {
        if(!bFound && i >= startRow)
        {
            let cell = grid[i][startCol];

            if(mode == "fast"){
                if(cell.input == 0)
                {
                    ret = {
                        row: i,
                        col: startCol
                    };
                    bFound = true;
                    
                }
            }
            else{

                    
                    if(!grid[i+1][startCol].isBlack){
                        ret = {
                            row: i+1,
                            col: startCol
                        };
                        bFound = true;
                    }
                
            }
        }
    }
    return ret;
}

function isLetter(key) {
    return key.toLowerCase() != key.toUpperCase() && key.length === 1
  }

  function isNextAcrossCellBlank({state},row, col)
  {
    var ret = true;

    let gC = state.cells;

    return ret;

  }


function noNeighbourCells({ dispatch, state }, pos) { 
    let cells = state.cells
    return (
        (state.isAcross && 
        (!cells[pos.row][pos.col+1] || cells[pos.row][pos.col+1].isBlack) &&
        (!cells[pos.row][pos.col-1] || cells[pos.row][pos.col-1].isBlack) ) ||
        (!state.isAcross && 
        (!cells[pos.row+1] || cells[pos.row+1][pos.col].isBlack) &&
        (!cells[pos.row-1] || cells[pos.row-1][pos.col].isBlack) ) )
}

const mutations = {
    // set a cell component as selected
    // pos = {row, col}
    CLEAR_CELLS(state) {
        state.cells = []
    },

    // set a cell component as selected
    // pos = {row, col}
    SET_SELECTED_CELL(state, p) {
        if (p) 
        {
            state.lastSelectedCell = state.selectedCell
            state.selectedCell = state.cells[p.row][p.col]
        }
        else 
        {
            state.lastSelectedCell = null
            state.selectedCell = null
        }
    },

    DESELECT_ALL_CELLS(state)
    {
        state.selectedCell = null
        state.lastSelectedCell = null
    },
    
    // p = {row, col, input}
    SET_SOLUTION_AT_POS(state, p) {
        let cell = state.cells[p.row][p.col]
        cell.input = p.solution
    },

    // p = {row, col, input}
    SET_USER_INPUT_AT_POS(state, p) {
        let cell = state.cells[p.row][p.col]
        cell.input = p.input
    },

    // p = {row, col, input}
    SET_USER_MARK_AT_POS(state, p) {        
        let cell = state.cells[p.row][p.col]

        p.input--

        if (cell.input !== 0) 
            cell.input = 0

        Vue.set(cell.marks, p.input, !cell.marks[p.input])
    },

    // p = {row, col, input}
    REMOVE_USER_MARK_AT_POS(state, p) {        
        let cell = state.cells[p.row][p.col]

        p.input--

        if (cell.input !== 0) 
            cell.input = 0

        Vue.set(cell.marks, p.input, false)
    },

    // p = {row, col, input}
    REFRESH_MARKS(state, p) {        
        state.cells[p.row][p.col].refreshMarks()
        // Vue.set(cell.marks, p.input, !cell.marks[p.input])
    },

    SET_LOADED(state, bool) {        
        state.loaded = bool
    },

    TOGGLE_IS_PENCIL(state) {
        state.isPencil = !state.isPencil
    },

    TOGGLE_IS_ACROSS(state) {
        state.isAcross = !state.isAcross
    },

    SET_IS_ACROSS(state, val) {
        state.isAcross = val
    },

}

export {
    state,
    getters,
    actions,
    mutations,
}